import { render, staticRenderFns } from "./Jobatal.vue?vue&type=template&id=fcceb12e&scoped=true&"
import script from "./Jobatal.vue?vue&type=script&lang=js&"
export * from "./Jobatal.vue?vue&type=script&lang=js&"
import style0 from "./Jobatal.vue?vue&type=style&index=0&id=fcceb12e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fcceb12e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDataTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VDataTable})
